import { render, staticRenderFns } from "./defaults.vue?vue&type=template&id=257fa19c"
import script from "./defaults.vue?vue&type=script&lang=js"
export * from "./defaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257fa19c')) {
      api.createRecord('257fa19c', component.options)
    } else {
      api.reload('257fa19c', component.options)
    }
    module.hot.accept("./defaults.vue?vue&type=template&id=257fa19c", function () {
      api.rerender('257fa19c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/main/defaults.vue"
export default component.exports